import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/img/icon_setting.svg'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header-basic" }
const _hoisted_3 = {
  key: 0,
  class: "top-row"
}
const _hoisted_4 = {
  class: "nav-second dropdown",
  style: {"z-index":"9999"}
}
const _hoisted_5 = { class: "dropdown-menu" }
const _hoisted_6 = {
  key: 1,
  class: "top-row"
}
const _hoisted_7 = { class: "nav-first" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "navbar-brand" }
const _hoisted_10 = { class: "nav-second" }
const _hoisted_11 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.$route.name == 'home')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "nav-first" }, null, -1)),
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "navbar-brand" }, [
              _createElementVNode("img", { src: "/img/tac.png" }),
              _createTextVNode(" 管理業務主任者士一問一答アプリ")
            ], -1)),
            _createElementVNode("div", _hoisted_4, [
              _cache[4] || (_cache[4] = _createElementVNode("button", {
                class: "btn",
                type: "button",
                "data-bs-toggle": "dropdown",
                "aria-expanded": "false",
                ontouchstart: ""
              }, [
                _createElementVNode("img", { src: _imports_0 })
              ], -1)),
              _createElementVNode("ul", _hoisted_5, [
                _createElementVNode("li", null, [
                  _createElementVNode("button", {
                    class: "dropdown-item",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)))
                  }, "初期化")
                ]),
                _cache[3] || (_cache[3] = _createElementVNode("li", { style: {"text-align":"right","padding-left":"1em","padding-right":"1em","font-size":"0.8em"} }, "Ver. 2.0", -1))
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (_ctx.routeState.leftBtn != '' && _ctx.routeState.leftAction != null)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.routeState.leftAction && _ctx.routeState.leftAction(...args))),
                    ontouchstart: ""
                  }, [
                    _createElementVNode("img", {
                      src: '/img/' + _ctx.routeState.leftBtn + '.svg'
                    }, null, 8, _hoisted_8)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.routeState.title), 1),
            _createElementVNode("div", _hoisted_10, [
              (_ctx.routeState.rightBtn != '' && _ctx.routeState.rightAction != null)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.routeState.rightAction && _ctx.routeState.rightAction(...args))),
                    ontouchstart: ""
                  }, [
                    _createElementVNode("img", {
                      src: '/img/' + _ctx.routeState.rightBtn + '.svg'
                    }, null, 8, _hoisted_11)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
    ])
  ]))
}